import tagularModule from 'js/store/helpers/tagular'

const navLinks = document.querySelectorAll(
  '[data-js-selector="nav-category-item"]'
)

const subCategories = document.querySelectorAll(
  '[data-js-selector="nav-subcategory"]'
)

const authDropdownToggle = document.querySelector(
  '[data-js-selector="toggle-auth-dropdown"]'
)

const authDropdown = document.querySelector(
  '[data-js-selector="auth-dropdown"]'
)
const createAccountButton = document.querySelector(
  '[data-js-selector="create-account-btn"]'
)

const signInButton = document.querySelector('[data-js-selector="sign-in-btn"]')

const getStartedAuthButtons = document.querySelectorAll(
  '[data-js-selector="get-started-auth-button"]'
)

const authSideBarButtons = document.querySelectorAll(
  '[data-js-selector="br-auth__nav-sidebar-link"]'
)

const searchToggle = document.querySelector(
  '[data-js-selector="search-toggle"]'
)

const navSearchSubmitBtn = document.querySelector(
  '[data-js-selector="nav-search-submit-btn"]'
)

const navSearchForm = document.querySelector(
  '[data-js-selector="nav-search-form"]'
)

// Click tracking for top level nav links
if (navLinks) {
  for (let i = 0; i < navLinks.length; i++) {
    let elem = navLinks[i]
    const label = elem.getAttribute('data-label').trim()
    const webElement = {
      elementType: 'link',
      location: 'global nav',
      position: `${i + 1}`,
      text: label,
      name: 'top-level'
    }

    elem.addEventListener('click', () =>
      tagularModule.elementClicked(webElement, `link to ${label} hub`)
    )
  }
}

// Click tracking for links under a category
if (subCategories) {
  for (let i = 0; i < subCategories.length; i++) {
    const subCategoryLinks = subCategories[i].querySelectorAll(
      'li a.br-header-nav__subcategory-item'
    )

    for (let j = 0; j < subCategoryLinks.length; j++) {
      let link = subCategoryLinks[j]
      const label = link.innerHTML.trim()
      const webElement = {
        elementType: 'link',
        location: 'global nav',
        position: `${j + 1}`,
        text: label,
        name: 'fly-out'
      }

      link.addEventListener('click', () =>
        tagularModule.elementClicked(webElement, `link to ${label}`)
      )
    }
  }
}

// Click tracking on the Auth buttons and dropdown
if (createAccountButton) {
  const webElement = {
    location: 'global_nav',
    position: 'RIGHT',
    elementType: 'button',
    text: 'Create_Account',
    htmlId: 'Create_account_nav-button'
  }
  createAccountButton.addEventListener('click', () =>
    tagularModule.elementClicked(
      webElement,
      createAccountButton.getAttribute('data-js-sign-up')
        ? 'link to sign up page'
        : 'link to create account page'
    )
  )
}

if (signInButton) {
  const webElement = {
    location: 'global_nav',
    position: 'RIGHT',
    elementType: 'button',
    text: 'Sign_In',
    htmlId: 'Sign_in_nav_button'
  }
  signInButton.addEventListener('click', () =>
    tagularModule.elementClicked(webElement, 'link to sign in page')
  )
}

if (getStartedAuthButtons) {
  const webElement = {
    location: 'global_nav',
    position: 'BOTTOM',
    elementType: 'button',
    text: 'Get_started',
    htmlId: 'get_started_nav_banner_authentication'
  }

  for (let i = 0; i < getStartedAuthButtons.length; i++) {
    getStartedAuthButtons[i].addEventListener('click', () =>
      tagularModule.elementClicked(
        webElement,
        getStartedAuthButtons[i].getAttribute('data-js-sign-up')
          ? 'link to sign up page'
          : 'link to create account page'
      )
    )
  }
}

if (authDropdownToggle) {
  const webElement = {
    elementType: 'button',
    location: 'global nav',
    position: '1',
    htmlId: authDropdownToggle.id,
    name: 'authentication CTA'
  }

  authDropdownToggle.addEventListener('click', () =>
    tagularModule.elementClicked(webElement, 'authenticated dropdown')
  )
}

// Click tracking for the authenticated dropdown links
if (authDropdown) {
  const authDropdownLinks = authDropdown.querySelectorAll(
    'li a.br-header__auth-link'
  )

  for (let i = 0; i < authDropdownLinks.length; i++) {
    let link = authDropdownLinks[i]
    const label = link.getAttribute('data-label').trim()
    const webElement = {
      elementType: 'button',
      location: 'global nav',
      position: `${i + 1}`,
      text: label,
      name: 'authentication dropdown'
    }

    link.addEventListener('click', () =>
      tagularModule.elementClicked(webElement, `link to authenticated ${label}`)
    )
  }
}

// Click tracking for the authenticated sidebar navigation
if (authSideBarButtons) {
  for (let i = 0; i < authSideBarButtons.length; i++) {
    let link = authSideBarButtons[i]
    let label = link.getAttribute('data-label')
    const webElement = {
      elementType: 'Button',
      htmlId: `Persistent_Nav_${label}_Icon`,
      location: document.title,
      position: 'left rail',
      text: `${label}_Icon`
    }
    link.addEventListener('click', () =>
      tagularModule.elementClicked(webElement, `/app/${label.toLowerCase()}`)
    )
  }
}

// Click tracking for the global search btn toggle
if (searchToggle) {
  const webElement = {
    elementType: 'button',
    location: 'global nav',
    position: '1',
    htmlId: searchToggle.id,
    name: 'search'
  }

  searchToggle.addEventListener('click', () =>
    tagularModule.elementClicked(webElement, 'link to site search')
  )
}

// Field Inputted tracking when a user searches using the nav search filter
if (navSearchSubmitBtn && navSearchForm) {
  navSearchSubmitBtn.addEventListener('click', () => {
    const inputValue = navSearchForm.querySelector('input[type=text]').value

    tagularModule.fieldInputted(
      'search bar',
      '[OMITTED]',
      'site search',
      inputValue,
      'site search',
      '[OMITTED]',
      'search',
      'site search'
    )
  })
}
